import styled from '@emotion/styled';
import { H4 } from '@ep/components/Typography';
import icons from '@ep/images/icons';
import theme from '@ep/theme';
import React from 'react';

export interface ButtonProps {
  label?: string;
  link?: string;
  icon?: string;
}

const StyledButton = styled.button`
  background-color: ${theme.colors.white};
  padding: 0;
  height: 12rem;
  width: 12rem;
  color: ${theme.colors.duskBlue};
  border: 1px solid ${theme.colors.black};
  outline: none;
  cursor: pointer;
  transition-property: background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  &:hover {
    background-color: ${theme.colors.gray};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const IconContainer = styled.div`
  width: 100%;
  svg {
    margin-top: 1rem;
  }
`;

const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 4rem;
  align-self: flex-end;
  margin-bottom: 20px;
`;

const SquareButton = ({ label, icon, ...rest }: ButtonProps) => {
  const Icon = icon && icons[icon as keyof typeof icons];

  return (
    <StyledButton {...rest}>
      <ButtonWrapper>
        {Icon && (
          <IconContainer>
            <Icon />
          </IconContainer>
        )}
        {label && (
          <Label className="labelBox">
            <H4>{label}</H4>
          </Label>
        )}
      </ButtonWrapper>
    </StyledButton>
  );
};

export default SquareButton;
